import { useEffect, useState } from "react";
import { Combobox, type ComboOption } from "../../../design/components";
import type { Level } from "./types";
import { useErpFields } from "./useProfileVersion";

export const SOURCE_QUERY_DEBOUNCE_MS = 200;

export function SourcePicker({
  id,
  label,
  value,
  level,
  entityId,
  disabled,
  onPick,
}: {
  id: string;
  label: string;
  value: string;
  level: Level;
  entityId: string | undefined;
  disabled?: boolean | undefined;
  onPick(source: string): void;
}) {
  const [typed, setTyped] = useState("");
  const [query, setQuery] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => setQuery(typed), SOURCE_QUERY_DEBOUNCE_MS);
    return () => clearTimeout(timer);
  }, [typed]);

  const fields = useErpFields(entityId, level, query);
  const options: ComboOption[] = (fields.data ?? []).map((field) => ({
    v: field.name,
    n: field.name,
    d: `${field.label} (${field.fieldtype})`,
  }));

  return (
    <Combobox
      id={id}
      ariaLabel={label}
      value={value}
      options={options}
      placeholder="Table.field"
      disabled={disabled}
      allowFreeText
      onQuery={setTyped}
      onPick={onPick}
    />
  );
}
